<template>
  <div class="">
    <div class="right-fixed">
      <div class="cooperate" @click="openCooperate">
        <i></i>
        <span>商务合作</span>
      </div>
      <div class="question" @click="openQuestion">
        <i></i>
        <span>问题反馈</span>
      </div>
      <div
        v-if="scrollTop > 500"
        ref="backTop"
        class="go-top"
        @click="backtop"
      ></div>
    </div>
    <div
      class="section-cont"
      style="height:530px;"
      @mouseenter="onMouseEnterSwiper"
      @mouseleave="onMouseLeaveSwiper"
    >
      <swiper ref="mySwiper" :options="swiperOption">
        <swiper-slide
          class="swiper-slide"
          v-for="(item, index) in carouselArr"
          :key="index"
        >
          <img width="100%" height="100%" :src="item" />
          <div
            v-if="index == 1"
            class="go-store"
            @click="
              GetCode(
                $config.Yqk.systemCode,
                $config.Yqk.pageUrl + '/gbaparkstore'
              )
            "
          ></div>
          <div
            v-if="index == 2"
            class="go-bigscreen"
            @click="
              GetCode(
                $config.Dp.systemCode,
                $config.Dp.pageUrl + '/parkbigscreen'
              )
            "
          ></div>
        </swiper-slide>
      </swiper>
      <div style="text-align:center;color:#909399">暂无数据</div>
      <!-- 分页器 -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- 左右箭头 -->
      <!-- <div v-if="carouselArr.length>4" class="swiper-button-prev" slot="button-prev"></div>
    <div v-if="carouselArr.length>4" class="swiper-button-next" slot="button-next"></div> -->
    </div>
    <div class="section-cont section-bg1">
      <div class="small-cont">
        <div class="usual-title">大湾区数据汇总</div>
        <div class="m-t-20 flex-cont self-cont-one">
          <div class="left-part">
            <div class="unit-cont">
              <div class="clearfix unit-item unit-item-h1">
                <div class="unit-icon pos1"></div>
                <div class="unit-text">
                  <div class="name">GDP总量</div>
                  <div class="num">
                    {{ baseInfo.gdpNum }}
                    <span class="unit">万亿元</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="unit-cont">
              <div class="clearfix unit-item unit-item-h1">
                <div class="unit-icon pos2"></div>
                <div class="unit-text">
                  <div class="name">人均GDP</div>
                  <div class="num">
                    {{ baseInfo.gdpavgNum }}
                    <span class="unit">万元</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="unit-cont">
              <div class="clearfix unit-item unit-item-h1">
                <div class="unit-icon pos3"></div>
                <div class="unit-text">
                  <div class="name">企业总数</div>
                  <div class="num">
                    <!-- {{baseInfo.companyNum}} -->
                    <!-- <span class="unit">个</span> -->
                    5604290
                    <span class="unit">家</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="unit-cont">
              <div class="clearfix unit-item unit-item-h1">
                <div class="unit-icon pos4"></div>
                <div class="unit-text">
                  <div class="name">园区总数</div>
                  <div class="num">
                    {{ baseInfo.parkNum }}
                    <span class="unit">个</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-item center">
            <div class="gbamap"></div>
            <!-- <gbamap :id="1"></gbamap> -->
            <!-- <img src="../../assets/images/gbamap.gif" style="width:744px" alt=""> -->
            <!-- <img src="../../assets/images/gbamap.png" alt=""> -->
          </div>
          <div class="right-part">
            <div class="unit-cont">
              <div
                class="clearfix unit-item unit-item-h1"
                style="
    padding-right: 10px;"
              >
                <div class="unit-icon pos1"></div>
                <div class="unit-text">
                  <div class="name">
                    上市企业<span style="font-size:2px;">(主板+新三板)</span>
                  </div>
                  <div class="num">
                    2365
                    <span class="unit">家</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="unit-cont">
              <div class="clearfix unit-item unit-item-h1">
                <div class="unit-icon pos2"></div>
                <div class="unit-text">
                  <div class="name">
                    百强企业<span style="font-size:2px;">(近2年)</span>
                  </div>
                  <div class="num">
                    2818
                    <span class="unit">家</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="unit-cont">
              <div class="clearfix unit-item unit-item-h1">
                <div class="unit-icon pos3"></div>
                <div class="unit-text">
                  <div class="name">国高企业</div>
                  <div class="num">
                    <!-- {{baseInfo.companyNum}} -->
                    <!-- <span class="unit">个</span> -->
                    57585
                    <span class="unit">家</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="unit-cont">
              <div class="clearfix unit-item unit-item-h1">
                <div class="unit-icon pos4"></div>
                <div class="unit-text">
                  <div class="name">瞪羚企业</div>
                  <div class="num">
                    1230
                    <span class="unit">家</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="advert" @click="openCooperate" style="cursor:pointer;">
        <a>
          <img src="../../assets/images/advertisement.png" alt="" />
        </a>
      </div>
    </div>
    <div class="section-cont section-bg2">
      <div class="small-cont">
        <div class="flex-cont self-cont-two">
          <!-- <div class="flex-item part-cont">
                    <div class="top-part part-bg1">园区指数</div>
                    <div class="bottom-part">
                    </div>
                </div> -->
          <div class="flex-item part-cont">
            <div class="top-part part-bg1">园区类型TOP10</div>
            <div class="bottom-part">
              <circlebar
                :id="2"
                :xAxisdata="chartdata.chart2.xAxisdata"
                :detaildata="chartdata.chart2.detaildata"
              >
              </circlebar>
            </div>
          </div>
          <div class="flex-item part-cont">
            <div class="top-part part-bg2">热门行业TOP10</div>
            <div class="bottom-part">
              <normalbar
                :id="3"
                :xAxisdata="chartdata.chart3.xAxisdata"
                :detaildata="chartdata.chart3.detaildata"
              >
              </normalbar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-cont section-bg1">
      <div class="small-cont">
        <div class="usual-title">大湾区产业热力图</div>
        <div
          class="m-t-20 self-cont-three p-5"
          style="background:#fff;height:535px"
        >
          <img src="../../assets/images/heatmap.gif" alt="" />
          <!-- <swiper ref="mySwiper1" :options="swiperOption1" style="height:535px;">
                    <swiper-slide class="swiper-slide" v-for="(item,index) in carouselArr1" :key="index">
                        <img width="1360" height="535" :src="item" />
                    </swiper-slide>
                </swiper> -->
        </div>
      </div>
    </div>
    <div class="section-cont section-bg2">
      <div class="small-cont">
        <div class="usual-title">大湾区9城园区榜单</div>
        <div class="self-cont-four">
          <el-tabs v-model="activeName">
            <el-tab-pane label="国家级" name="first">
              <el-table :data="tableData1" style="width: 100%" height="500">
                <el-table-column prop="name" label="园区名"> </el-table-column>
                <el-table-column prop="qualification" label="资质">
                </el-table-column>
                <!-- <el-table-column prop="year" label="认定年份">
                </el-table-column> -->
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="省级" name="second">
              <el-table :data="tableData2" style="width: 100%" height="500">
                <el-table-column prop="name" label="园区名"> </el-table-column>
                <el-table-column prop="qualification" label="资质">
                </el-table-column>
                <!-- <el-table-column prop="year" label="认定年份">
                </el-table-column> -->
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="市级" name="third">
              <el-table :data="tableData3" style="width: 100%" height="500">
                <el-table-column prop="name" label="园区名"> </el-table-column>
                <el-table-column prop="qualification" label="资质">
                </el-table-column>
                <!-- <el-table-column prop="year" label="认定年份">
                </el-table-column> -->
              </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="区级" name="area">
                        <el-table :data="tableData4" style="width: 100%" height="500">
                            <el-table-column prop="name" label="园区名">
                            </el-table-column>
                            <el-table-column prop="qualification" label="资质">
                            </el-table-column>
                            <el-table-column prop="year" label="认定年份">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane> -->
          </el-tabs>
        </div>
        <!-- <div class="usual-title m-t-20">高活跃度园区榜单</div>
            <div class="self-cont-four">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="name" label="园区名">
                    </el-table-column>

                    <el-table-column prop="address" label="所属城市">
                    </el-table-column>
                    <el-table-column prop="qualification" label="资质">
                    </el-table-column>
                </el-table>
            </div> -->
        <div class="flex-cont m-t-20">
          <div class="flex-item m-r-50">
            <div class="usual-title">政策信息</div>
            <div class="self-cont-five m-t-20">
              <div
                class="flex-cont row-info"
                v-for="(item, index) in infos1"
                :key="index">
                <i class="rect"></i>
                <div class="part">
                  {{ item.name.replace('"', "").replace('"', "") }}
                </div>
                <div class="flex-item address">{{ item.area }}</div>
              </div>
            </div>
          </div>
          <div class="separate"></div>
          <div class="flex-item m-l-50">
            <div class="usual-title">土地信息</div>
            <div class="self-cont-five m-t-20">
              <div
                class="flex-cont row-info"
                v-for="(item, index) in infos2"
                :key="index">
                <i class="rect"></i>
                <div class="part">
                  {{ item.name.replace('"', "").replace('"', "") }}
                </div>
                <div class="flex-item address">{{ item.area }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-cont section-bg1">
      <div class="small-cont">
        <div class="clearfix self-tabs">
          <div
            class="tab"
            :class="toggelflag == '1' ? 'tab-active' : ''"
            @click="toggleinfo('1')"
          >
            展会资讯
          </div>
          <div
            class="tab"
            :class="toggelflag == '2' ? 'tab-active' : ''"
            @click="toggleinfo('2')"
          >
            活动资讯
          </div>
        </div>
        <div class="information-cont">
          <div class="information-flex">
            <div
              class="information-item"
              v-for="model in viewData"
              :key="model.id"
            >
              <img
                :src="
                  toggelflag == '1'
                    ? require('../../assets/images/infoimg1.png')
                    : require('../../assets/images/infoimg2.png')
                "
                :alt="toggelflag == '1' ? '展会资讯' : '活动资讯'"
              />
              <div class="details">
                <div class="row-item-a">
                  <!-- <div :class="model.type==1?'tip tip2':'tip tip1'">
                                    {{model.type==1?"活动资讯":"展会资讯"}}
                                    <i class="corner"></i>
                                </div> -->
                  <a
                    v-if="model.url"
                    target="_blank"
                    class="title"
                    :href="model.url"
                    :title="model.title"
                    >{{ model.title ? model.title : "-" }}</a
                  >
                  <a v-if="!model.url" class="title" :title="model.title">{{
                    model.title ? model.title : "-"
                  }}</a>
                </div>
                <!-- <p class="row-item">
                  <span class="unit">时间：</span>
                  <span
                    class="context"
                    :title="model.starTime + ' 至 ' + model.endTime"
                    >{{ model.starTime + " 至 " + model.endTime }}</span
                  >
                </p> -->

                <p class="row-item">
                  <span class="unit">时间：</span>
                  <span class="context" :title="model.starTime">{{
                    model.starTime
                  }}</span>
                </p>
                <p class="row-item">
                  <span class="unit">地点：</span>
                  <span
                    class="context"
                    :title="model.address ? model.address : '-'"
                    >{{ model.address ? model.address : "-" }}</span
                  >
                </p>
                <p class="row-item">
                  <span class="unit">主办方：</span>
                  <span
                    class="context selfspan"
                    :title="model.host ? model.host : '-'"
                    >{{ model.host ? model.host : "-" }}</span
                  >
                </p>
                <p class="row-item">
                  <span class="unit">{{
                    model.type == 2 ? "限额人数：" : "所属行业："
                  }}</span>
                  <span class="context">{{
                    model.type == 2
                      ? model.number
                        ? model.number + "人"
                        : "-"
                      : model.number
                      ? model.number
                      : "-"
                  }}</span>
                </p>
                <!-- <el-button v-if="model.type==2" type="warning" size="mini" class="more-btn">历年参展商</el-button> -->
                <!-- <router-link v-if="model.type==2" target="_blank" :to="{path:'/canvassDetails',query:{name:model.title}}" class="more-btn">历年参展商
                                </router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-cont section-bg3">
      合纵数据<span></span>智慧园区数据生态服务
    </div>
    <commonfooter></commonfooter>
    <el-dialog
      title="商务合作"
      :visible.sync="cooperateDialog"
      center
      width="40%"
      :close-on-click-modal="false"
      :lock-scroll="false"
      class="self-dialog"
    >
      <el-form
        ref="cooperateForm"
        :model="cooperateForm"
        :rules="cooperateRules"
        label-width="100px"
      >
        <el-form-item label="公司名称：" prop="companyname">
          <el-input
            v-model="cooperateForm.companyname"
            size="medium"
            autocomplete="off"
            placeholder="您的公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="name">
          <el-col :span="11" class="m-r-20">
            <el-input
              v-model="cooperateForm.name"
              size="medium"
              autocomplete="off"
              placeholder="您的姓名"
            ></el-input>
          </el-col>
          <el-col :span="11">
            <el-input
              v-model="cooperateForm.phone"
              size="medium"
              autocomplete="off"
              placeholder="您的手机号"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="其他联系：">
          <el-col :span="11" class="m-r-20">
            <el-input
              v-model="cooperateForm.wechat"
              size="medium"
              autocomplete="off"
              placeholder="您的微信号"
            ></el-input>
          </el-col>
          <el-col :span="11">
            <el-input
              v-model="cooperateForm.email"
              size="medium"
              autocomplete="off"
              placeholder="您的电子邮箱"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="意向产品：" prop="intention">
          <el-select
            v-model="cooperateForm.intention"
            size="medium"
            placeholder="请选择意向产品"
            multiple
            collapse-tags
          >
            <el-option
              label="大湾区产业地图"
              value="大湾区产业地图"
            ></el-option>
            <el-option label="大湾区园区库" value="大湾区园区库"></el-option>
            <el-option label="园区大屏" value="园区大屏"></el-option>
            <el-option label="行业信息" value="行业信息"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向描述：">
          <el-input
            type="textarea"
            :rows="2"
            size="medium"
            placeholder="请输入内容"
            v-model="cooperateForm.description"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="企业简介：">
          <el-input
            type="textarea"
            :rows="2"
            size="medium"
            placeholder="请输入内容"
            v-model="cooperateForm.introduction"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitCooperate('cooperateForm')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="问题反馈"
      :visible.sync="questionDialog"
      center
      width="40%"
      :close-on-click-modal="false"
      :lock-scroll="false"
      class="self-dialog"
    >
      <el-form
        ref="questionForm"
        :model="questionForm"
        :rules="questionRules"
        label-width="100px"
      >
        <el-form-item label="联系人：" prop="name">
          <el-col :span="11" class="m-r-20">
            <el-input
              v-model="questionForm.name"
              size="medium"
              autocomplete="off"
              placeholder="您的姓名"
            ></el-input>
          </el-col>
          <el-col :span="11">
            <el-input
              v-model="questionForm.phone"
              size="medium"
              autocomplete="off"
              placeholder="您的手机号"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="其他联系：">
          <el-col :span="11" class="m-r-20">
            <el-input
              v-model="questionForm.wechat"
              size="medium"
              autocomplete="off"
              placeholder="您的微信号"
            ></el-input>
          </el-col>
          <el-col :span="11">
            <el-input
              v-model="questionForm.email"
              size="medium"
              autocomplete="off"
              placeholder="您的电子邮箱"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="问题描述：" prop="description">
          <el-input
            type="textarea"
            :rows="2"
            size="medium"
            placeholder="请输入内容"
            v-model="questionForm.description"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="上传图片：">
          <el-upload
            ref="upload"
            action
            accept=".jpg,.jpeg ,.png"
            :auto-upload="false"
            :limit="1"
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :file-list="questionForm.fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip" style="line-height:10px;">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="验证码：" prop="vercode">
          <el-input
            v-model="code"
            size="medium"
            autocomplete="off"
            placeholder="请输入验证码"
            style="width:150px;"
          ></el-input>
          <div
            class="yzm"
            title="点击刷新"
            @click="refreshCode"
            style="display:inline-block"
          >
            <pagecode id="page1" :identifyCode="identifyCode"></pagecode>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onUploadSubmit('questionForm')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonfooter from "../../common/commonfooter";
import gbamap from "../../common/gbamap";
import circlebar from "../../common/circlebar";
import normalbar from "../../common/normalbar";
import qs from "qs";
import pagecode from "../../common/pagecode";
import { getRequestCode } from "../../api/api.js";
export default {
  name: "",
  data() {
    const nameorphone = (rule, value, callback) => {
      if (!value.trim()) {
        return callback(new Error("请输入姓名"));
      } else if (this.cooperateForm.phone == "") {
        return callback(new Error("请输入手机号"));
      } else {
        callback();
      }
    };
    const nameorphone1 = (rule, value, callback) => {
      if (!value.trim()) {
        return callback(new Error("请输入姓名"));
      } else if (this.questionForm.phone == "") {
        return callback(new Error("请输入手机号"));
      } else {
        callback();
      }
    };
    return {
      toggelflag: "1",
      activeName: "first",
      tableData: [
        {
          name: "2016-05-02",
          intelligence: "王小虎",
          city: "上海市普陀区金沙江路 1518 弄"
        },
        {
          name: "2016-05-02",
          intelligence: "王小虎",
          city: "上海市普陀区金沙江路 1518 弄"
        },
        {
          name: "2016-05-02",
          intelligence: "王小虎",
          city: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      viewData: [],
      viewData1: [],
      viewData2: [],
      carouselArr: [
        require("../../assets/images/swiper-img1.png"),
        require("../../assets/images/swiper-img2.png"),
        require("../../assets/images/swiper-img3.png"),
        require("../../assets/images/swiper-img4.png")
      ],
      carouselArr1: [
        require("../../assets/images/heatmap-bg1.png"),
        // require("../../assets/images/heatmap-bg2.png"),
        require("../../assets/images/heatmap-bg3.png"),
        require("../../assets/images/heatmap-bg4.png"),
        require("../../assets/images/heatmap-bg5.png")
      ],
      swiperOption: {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true
      },
      swiperOption1: {
        loop: true,
        effect: "fade",
        //自动轮播
        autoplay: {
          delay: 1000,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true
      },
      chartdata: {
        chart2: {
          xAxisdata: [
            "物流园",
            "写字楼",
            "文创园",
            "科技园",
            "工业园",
            "工业园1",
            "工业园2",
            "工业园3",
            "工业园4",
            "工业园5"
          ],
          detaildata: [80, 65, 45, 40, 30, 29, 28, 27, 26, 25]
        },
        chart3: {
          xAxisdata: [
            "数字出版",
            "数字电视",
            "数字音乐",
            "卫星及应用",
            "新材料",
            "新材料1",
            "新材料2",
            "新材料3",
            "新材料4",
            "新材料5"
          ],
          detaildata: [80, 65, 45, 40, 30, 29, 28, 27, 26, 25]
        }
      },
      baseInfo: {},
      infos1: [],
      infos2: [],
      scrollTop: 0,
      cooperateDialog: false,
      cooperateForm: {
        companyname: "",
        name: "",
        phone: "",
        wechat: "",
        email: "",
        intention: [],
        description: "",
        introduction: ""
      },
      cooperateRules: {
        companyname: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            validator: nameorphone,
            trigger: "blur"
          }
        ],
        intention: [
          {
            required: true,
            message: "请选择意向产品",
            trigger: "change"
          }
        ]
      },
      questionDialog: false,
      questionForm: {
        name: "",
        phone: "",
        wechat: "",
        email: "",
        description: "",
        fileList: []
      },
      questionRules: {
        name: [
          {
            required: true,
            validator: nameorphone1,
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: "请输入问题描述",
            trigger: "blur"
          }
        ]
      },
      identifyCodes: "1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      identifyCode: "",
      code: "" //text框输入的验证码,
    };
  },
  components: {
    commonfooter,
    gbamap,
    circlebar,
    normalbar,
    pagecode
  },
  computed: {
    mySwiper() {
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.mySwiper.$swiper;
    }
  },
  created() {
    this.GetData();
  },
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
    this.viewData = this.viewData1;
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let _this = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      _this.scrollTop = scrollTop;
    },
    onMouseEnterSwiper() {
      this.mySwiper.autoplay.stop();
    },
    onMouseLeaveSwiper() {
      this.mySwiper.autoplay.start();
    },
    //获取数据
    GetData(SysId, url) {
      let _this = this;
      let StrJson = {
        d: ""
      };
      let params = qs.stringify({
        StrJson: JSON.stringify(StrJson)
      });
      _this.$http
        .post("/Api/GetBaseInfo", params)
        .then(function(response) {
          let res = response.data;
          if (res.code == 1) {
            //console.log(res.data);
            let data = res.data;
            //基础信息
            _this.baseInfo = data.baseInfo;
            //园区类型TOP10
            let chart2 = {
              xAxisdata: [],
              detaildata: []
            };
            let yuanqutypeInfos = data.yuanqutypeInfos;
            if (yuanqutypeInfos && yuanqutypeInfos.length > 0) {
              for (let i = 0; i < yuanqutypeInfos.length; i++) {
                let x = yuanqutypeInfos[i].typeName;
                let num = yuanqutypeInfos[i].num;
                chart2.xAxisdata.push(x);
                chart2.detaildata.push(num);
              }
              _this.chartdata.chart2 = chart2;
            }
            //园区类型TOP10
            let chart3 = {
              xAxisdata: [],
              detaildata: []
            };
            let hotfieldInfos = data.hotfieldInfos;
            if (hotfieldInfos && hotfieldInfos.length > 0) {
              for (let i = 0; i < hotfieldInfos.length; i++) {
                let x = hotfieldInfos[i].typeName;
                let num = hotfieldInfos[i].num;
                chart3.xAxisdata.push(x);
                chart3.detaildata.push(num);
              }
              _this.chartdata.chart3 = chart3;
            }
            //政策信息
            _this.infos1 = data.infos1;
            //土地信息
            _this.infos2 = data.infos2;
            //展会资讯
            let viewData1 = [];
            let actives1 = data.actives1;
            if (actives1 && actives1.length > 0) {
              for (let i = 0; i < actives1.length; i++) {
                let model = {
                  type: 1,
                  id: i,
                  url: actives1[i].pageUrl.replace('"', "").replace('"', ""),
                  title: actives1[i].name.replace('"', "").replace('"', ""),
                  starTime: actives1[i].startTime.substring(0, 10),
                  endTime: actives1[i].endTime.substring(0, 10),
                  address: actives1[i].address
                    .replace('"', "")
                    .replace('"', ""),
                  host:
                    actives1[i].sponsor &&
                    actives1[i].sponsor.trim().toLowerCase() != '"null"'
                      ? actives1[i].sponsor.replace('"', "").replace('"', "")
                      : "-",
                  number:
                    actives1[i].limitNum &&
                    actives1[i].limitNum.trim().toLowerCase() != '"null"'
                      ? actives1[i].limitNum.replace('"', "").replace('"', "")
                      : "-"
                };
                viewData1.push(model);
              }
              _this.viewData1 = viewData1;
              _this.viewData = viewData1;
            }
            //活动资讯
            let viewData2 = [];
            let actives2 = data.actives2;
            if (actives2 && actives2.length > 0) {
              for (let i = 0; i < actives2.length; i++) {
                let model = {
                  type: 2,
                  id: i,
                  url: actives2[i].pageUrl.replace('"', "").replace('"', ""),
                  title: actives2[i].name.replace('"', "").replace('"', ""),
                  starTime: actives2[i].startTime.substring(0, 10),
                  endTime: actives2[i].endTime.substring(0, 10),
                  address: actives2[i].address
                    .replace('"', "")
                    .replace('"', ""),
                  host:
                    actives2[i].sponsor &&
                    actives1[i].sponsor.trim().toLowerCase() != '"null"'
                      ? actives2[i].sponsor.replace('"', "").replace('"', "")
                      : "-",
                  number:
                    actives2[i].limitNum &&
                    actives1[i].limitNum.trim().toLowerCase() != '"null"'
                      ? actives2[i].limitNum.replace('"', "").replace('"', "")
                      : "-"
                };
                viewData2.push(model);
              }
              _this.viewData2 = viewData2;
            }
            //高活跃度园区榜单
            _this.tableData = data.activeparkRanks;
            //大湾区9城园区榜单
            _this.tableData1 = data.parkRanks1;

            _this.tableData1.map(obj => {
              var year = obj.year;
              year = year.substring(0, year.lastIndexOf("年"));
              obj.year = Number(year) + 1;
            });

            _this.tableData2 = data.parkRanks2;

            _this.tableData2.map(obj => {
              var year = obj.year;
              year = year.substring(0, year.lastIndexOf("年"));
              obj.year = Number(year) + 1;
            });

            _this.tableData3 = data.parkRanks3;

            _this.tableData3.map(obj => {
              var year = obj.year;
              year = year.substring(0, year.lastIndexOf("年"));
              obj.year = Number(year) + 1;
            });

            _this.tableData4 = data.parkRanks4;
          } else {
            this.commonTipsError(res.result);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    toggleinfo: function(e) {
      this.toggelflag = e;
      if (this.toggelflag == "1") {
        this.viewData = this.viewData1;
      } else {
        this.viewData = this.viewData2;
      }
    },
    //返回顶部
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 3);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    openCooperate() {
      this.cooperateForm = {
        companyname: "",
        name: "",
        phone: "",
        wechat: "",
        email: "",
        intention: [],
        description: "",
        introduction: ""
      };
      this.cooperateDialog = true;
    },
    openQuestion() {
      let token = localStorage.getItem("parkToken");
      if (!token) {
        this.commonTipsError("请登录之后再使用该功能");
        return;
      }
      this.questionForm = {
        name: "",
        phone: "",
        wechat: "",
        email: "",
        description: "",
        fileList: []
      };
      this.identifyCode = "";
      this.code = "";
      this.makeCode(this.identifyCodes, 4);
      this.questionDialog = true;
    },
    //提交商务合作
    submitCooperate(formName) {
      let _this = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let productArray = _this.cooperateForm.intention;
          let products = "";
          if (productArray.length > 0) {
            for (let i = 0; i < productArray.length; i++) {
              products += productArray[i] + ",";
            }
            products = products.substring(0, products.length - 1);
          }
          let StrJson = {
            CompanyName: _this.cooperateForm.companyname,
            Name: _this.cooperateForm.name,
            Phone: _this.cooperateForm.phone,
            Wx: _this.cooperateForm.wechat,
            Email: _this.cooperateForm.email,
            Product: products,
            Remark: _this.cooperateForm.description,
            Introduce: _this.cooperateForm.introduction
          };
          let params = qs.stringify({
            StrJson: JSON.stringify(StrJson)
          });
          _this.$http
            .post("/Api/ToSubmitContact", params)
            .then(function(response) {
              let res = response.data;
              if (res.code == 1) {
                _this.cooperateDialog = false;
                _this.commonTipsSuccess("提交成功");
              } else {
                _this.commonTipsError(res.result);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    //提交问题反馈
    submitQuestion(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
    //上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    diaUpload() {
      this.uploadShow = false;
    },
    validateFile: function(rule, value, callback) {
      if (!this.$refs.upload.uploadFiles.length) {
        callback(new Error("请选择导入的文件"));
      } else if (this.$refs.upload.uploadFiles.length > 1) {
        callback(new Error("只能上传一个文件"));
      } else if (
        this.$refs.upload.uploadFiles[this.$refs.upload.uploadFiles.length - 1]
          .size > 512000
      ) {
        callback(new Error("上传的文件大小超过500K"));
      } else {
        callback();
      }
    },
    handleChange(file, fileList, name) {
      this.$refs.questionForm.validateField("files");
      if (typeof fileList == "undefined" || fileList.length <= 0) {
        this.fileList = [];
      } else {
        this.fileList = fileList;
      }
    },
    handleExceed() {
      this.$refs.questionForm.validateField("files");
    },

    onUploadSubmit() {
      let _this = this;
      let token = localStorage.getItem("parkToken");
      if (!token) {
        _this.commonTipsError("请登录之后再尝试");
        return;
      }
      this.$refs.questionForm.validate(valid => {
        if (valid) {
          if (_this.code !== _this.identifyCode) {
            _this.commonTipsError("请输入正确的验证码");
            return false;
          }
          let model = {
            Name: _this.questionForm.name,
            Phone: _this.questionForm.phone,
            Wx: _this.questionForm.wechat,
            Email: _this.questionForm.email,
            Describes: _this.questionForm.description
          };
          _this.UploadLoad = true;
          const formData = new FormData();
          let url = "/Api/ToSubmitProblem";
          if (_this.$refs.upload.uploadFiles.length > 0) {
            formData.append("files", _this.$refs.upload.uploadFiles[0].raw);
          } else {
            url = "/Api/ToSubmitProblemNoFile";
          }
          formData.append("StrJson", JSON.stringify(model));
          _this.$http
            .post(url, formData)
            .then(function(response) {
              let res = response.data;
              console.log(res);
              if (res.code == 1) {
                _this.commonTipsSuccess("上传成功！");
                //_this.loadData();
                _this.questionDialog = false;
              } else if (res.code == 0) {
                _this.commonTipsError(res.result);
              }
              _this.UploadLoad = false;
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      });
    },

    GetCode(SysId, url) {
      let params = {
        SystemId: SysId
      };
      var parkToken = localStorage.getItem("parkToken");
      if (!parkToken) {
        //直接跳转http
        window.location.href = url;
      } else {
        getRequestCode(params)
          .then(function(response) {
            let res = response.data;
            if (res.code == 1) {
              //console.log('');
              window.location.href = url + "?code=" + res.data;
            } else {
              // if (res.code == -10) {
              //   this.commonTipsError(res.result);
              // } else {
              this.commonTipsError("授权失败");
              //}
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    //验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/index/main.vue